import React from 'react'
import { Button, Paper, TextField } from '@mui/material'
import cover from '../assets/cover.jpg';



import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { setLogin } from '../redux/loginSlice';
import { Container, margin, padding } from '@mui/system';
import { InputLabel, FilledInput, InputAdornment, IconButton } from '@mui/material';
import { OutlinedInput } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';


const style = {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 600,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: '0 5px 16px rgba(0, 0, 0, 0.2)',
    p: 4,
    // overflowY: 'scroll',
    // overflowX: 'hidden',
    maxHeight: '100vh',
    outline: 'none',
    padding: 'none',
    margin: 'none'
};

const Login = () => {
    const dispatch = useDispatch();
    const login = useSelector(state => state.login.value);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        // make a fetch fetch get request to check if the user is logged in already
        fetch("https://werkvoorbereiding.divoduurzaam.nl/assets/php/security/autologin.php")
        .then(response => response.json())
        .then(data => {
            if (data === 1) {
                dispatch(setLogin(true));
            }
        })
        .catch(error => {
            console.log(error);
        }
        )
    }, [])
    

    const handleLogin = () => {

        // use a fetch request to send the username and password to the server
        const formData = new FormData();

        formData.append("userName", username);
        formData.append("password", password); 

        fetch("https://werkvoorbereiding.divoduurzaam.nl/assets/php/security/login.php", {
            method: "POST",
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data === 1) {
                dispatch(setLogin(true));
            }
        })
        .catch(error => {
            console.log(error);
        })
        
    }
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    }


  return (
        <Container>
            <Paper sx={style}>
                {/* make two columns */}

                <div style={{marginRight: '20px'}}>
                    <img style={{height: '100%', maxWidth:'100%', borderRadius: "8px 0px 0px 8px"}} src={cover} alt="Divo Duurzaam" />
                </div>

                <Container sx={{padding: '20px'}}>
                    <h1>Werkvoorbereiding</h1>
                    <Container sx={{marginBottom: '30px'}}>
                        <InputLabel htmlFor="outlined-basic">Username</InputLabel>
                        <OutlinedInput 
                            id="outlined-basic" 
                            variant="outlined"
                            sx={{width: '100%'}} 
                            onChange={(e) => setUsername(e.target.value)}/>
                    </Container>
                    <Container sx={{marginBottom: '30px'}}>
                    <InputLabel htmlFor="filled-adornment-password">Password</InputLabel>
                        <OutlinedInput
                            id="filled-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyPress={handleKeyPress}
                            sx={{width: '100%'}} 
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword(!showPassword)}
                                onMouseDown={ () => setShowPassword(!showPassword)}
                                edge="end"
                                >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            }
                        />

                        {/* <TextField id="outlined-basic" label="Wachtwoord" variant="outlined" onChange={(e) => setPassword(e.target.value)} /> */}
                    </Container>
                    <Container sx={{marginBottom: '30px'}}>
                        <Button variant="contained" color="primary" onClick={() => handleLogin() }>Log in</Button>
                    </Container>
                </Container>


            </Paper>
        </Container>



  )
}

export default Login